import React, { useContext, useRef } from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';

const H6 = ({ numberOfLines = 1, style, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h6);

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'H6',
                fontFamily: layout.styleGuide.h6.fontFamily,
                condensedFontFamily: layout.styleGuide.h6.condensedFontFamily,
                fontSize: layout.styleGuide.h6.fontSize,
                color: layout.styleGuide.h6.color
            }}
            numberOfLines={numberOfLines}
            ref={ref}
            style={StyleSheet.flatten([Style.h6, layout.styleGuide.h6, overflowStyle, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h6: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '11pt' : 11
    }
});

H6.propTypes = {
    style: PropTypes.object,
    text: PropTypes.string
};

export default H6;
